import axios from "axios";

const useDispatchOrder = () => {
  // used for both equipment only order and uzeli order for setup devices
  const dispatchOrder = async ({
    recipientName,
    recipientAddress: {
      shippingAddress1,
      shippingAddress2,
      shippingAddressCity,
      shippingAddressState,
      shippingAddressZipCode,
      businessName,
    },
    recipientEmail,
    recipientPhone,
    products,
    referenceId,
    paymentStatus,
    invoiceId,
  }) => {
    try {
      const res = await axios.post(
        `/browser/dispatchOrder`,
        {
          recipientName: recipientName,
          recipientAddress: {
            shippingAddress1,
            shippingAddress2,
            shippingAddressCity,
            shippingAddressState,
            shippingAddressZipCode,
            businessName,
          },
          recipientEmail,
          recipientPhone,
          products,
          referenceId,
          paymentStatus,
          invoiceId,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return res?.data;
    } catch (err) {
      console.log("Something went wrong");
      return err;
    }
  };

  return { dispatchOrder };
};

export default useDispatchOrder;
